import { TbInfoSquareRounded } from 'react-icons/tb';
import { useDisclosure } from '@/core/hooks';
import { cn, Information, type InformationProps } from '../../ui';

interface Props extends Omit<React.ComponentProps<'div'>, 'title'> {
  title: React.ReactNode;
  showInfo?: boolean;
  infoProps?: Omit<InformationProps, 'isOpen' | 'onOpenChange'>;
  textClassName?: string;
  description?: React.ReactNode;
}

export const Heading = ({
  className,
  title,
  children,
  showInfo = false,
  infoProps,
  textClassName,
  description,
}: Props) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  return (
    <>
      {showInfo && (
        <Information
          isOpen={isOpen}
          onOpenChange={onOpenChange}
          type='info'
          title='Information'
          {...infoProps}
        />
      )}
      <div
        className={cn(
          'py-6 px-6 md:px-10',
          'border-b border-divider ',
          'justify-between flex items-center',
          className,
        )}
      >
        <div className='flex flex-col gap-2'>
          <div className='flex items-center space-x-4'>
            {typeof title === 'string' ? (
              <h4 className={cn('text-xl md:text-2xl', textClassName)}>{title}</h4>
            ) : (
              title
            )}
            {showInfo && (
              <TbInfoSquareRounded onClick={onOpen} className='text-foreground-600 cursor-pointer w-7 h-7' />
            )}
          </div>
          {description}
        </div>
        {children}
      </div>
    </>
  );
};
